import { AnyAction } from 'redux'
import { PageId } from '~/shared/constants/pagesConstants'
import { ScreenName } from '~/shared/services/eventLogger'
import { IAction, IAppState, TAppDispatchThunk } from '~/shared/store/types'
import { IDynamicDiscount, TAnswer } from '~/shared/types/commonTypes'
import { IAppConfig } from '~/shared/types/configTypes'
import { IVariant } from '~/shared/types/variantTypes'

import {
  RESET_ERROR,
  SET_ANSWERS,
  SET_ANSWERS_FROM_BACKEND,
  SET_APP_CONFIG,
  SET_DYNAMIC_DISCOUNT,
  SET_ERROR,
  SET_IS_CONTEXT_ENABLED,
  SET_LANGUAGE,
  SET_SCREEN_NAME,
  SET_VARIANT,
  START_FETCHING,
  STOP_FETCHING,
} from '../actionTypes'

export function setAppConfigAction(payload: IAppConfig): IAction<IAppConfig> {
  return {
    type: SET_APP_CONFIG,
    payload,
  }
}

export function startFetching(action: string): IAction<string> {
  return {
    type: START_FETCHING,
    payload: action,
  }
}

export function stopFetching(actionToStop: string): any {
  return (dispatch: TAppDispatchThunk<string[]>, getState: () => IAppState) => {
    const runningActions = getState().common.actionList
    const fetchList = runningActions.filter(
      (action: string) => action && action !== actionToStop,
    )

    dispatch({
      type: STOP_FETCHING,
      payload: fetchList,
    })
  }
}

export function setErrorAction<T>(error: T): IAction<T> {
  return {
    type: SET_ERROR,
    payload: error,
  }
}

export function resetErrorAction(): IAction<never> {
  return {
    type: RESET_ERROR,
  }
}

export function setVariantAction(payload: IVariant): IAction<IVariant> {
  return {
    type: SET_VARIANT,
    payload,
  }
}

export function setLanguageAction(language: string): IAction<string> {
  return {
    type: SET_LANGUAGE,
    payload: language,
  }
}

export function setAnswersAction({
  answers,
  pageId,
}: {
  answers: TAnswer
  pageId: string
}): AnyAction {
  return {
    type: SET_ANSWERS,
    payload: { [pageId]: answers },
  }
}

export function setMultipleAnswerAction({
  answers,
}: {
  answers: Record<string, string | string[] | number>
}): AnyAction {
  return {
    type: SET_ANSWERS,
    payload: answers,
  }
}

export function setAnswersFromBackendAction(
  answers: Record<PageId, TAnswer>,
): AnyAction {
  return {
    type: SET_ANSWERS_FROM_BACKEND,
    payload: answers,
  }
}

export function setScreenNameAction(
  screenName: ScreenName,
): IAction<ScreenName> {
  return {
    type: SET_SCREEN_NAME,
    payload: screenName,
  }
}

export function setDynamicDiscountAction(
  payload: IDynamicDiscount,
): IAction<IDynamicDiscount> {
  return {
    type: SET_DYNAMIC_DISCOUNT,
    payload,
  }
}

export function setIsInContextEnabledAction(
  payload: boolean,
): IAction<boolean> {
  return {
    type: SET_IS_CONTEXT_ENABLED,
    payload,
  }
}
